import { AfterViewInit, Component, inject } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Occupant, RelatedOccupant } from '@app/core/model/entities/asset/occupant';
import { OccupantsService } from '@app/features/main/views/organization-occupants/occupants.service';
import {
  MatSelectEntityAutocompleteServerComponent
} from '@app/shared/components/mat-select-autocomplete/mat-select-entity-autocomplete/mat-select-entity-autocomplete-server/mat-select-entity-autocomplete-server.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'mat-select-occupant-autocomplete',
  styleUrls: ['../mat-select-entity-autocomplete.component.scss'],
  templateUrl: '/mat-select-entity-autocomplete-server.component.html',
  providers: [
    {provide: MatFormFieldControl, useExisting: MatSelectOccupantAutocompleteComponent}
  ],
  standalone: false
})
export class MatSelectOccupantAutocompleteComponent extends MatSelectEntityAutocompleteServerComponent<RelatedOccupant, Occupant> {
  private occupantService = inject(OccupantsService);

  /**
   * Load occupants next page.
   * @param startingIndex Page to load. NB: First page is 0.
   * @return Observable<RelatedOccupant[]> A list of RelatedOccupant matching the form filters.
   */
  public loadEntitiesNextPage(startingIndex: number): Observable<RelatedOccupant[]> {
    const params = {...this.buildSelectParams(), start: startingIndex};
    return this.occupantService.loadOccupantsPage(params)
      .pipe(map(occupants => occupants.map(occupant => occupant.toRelatedOccupant())));
  }
}
